export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YL5rilUs6yLUrwB0lw.6f414d64.woff2";